module.exports = __webpack_public_path__ + "img/H1.da3006bb.png";